import data from "app/assets/files/key-value-translations/eol-plannning-overview-page.json";
import { insertCategoryAndIndex, IQuestionAnswer } from "app/components/composites/Category/QnACategory";
import PageHeader from "app/components/composites/PageHeader";
import { GuidesBulletList } from "app/components/templates/Guide/__common__";
import OverviewPage from "app/components/templates/Overview";
import { useGlobalLanguageState } from "app/utils/internationalization/GlobalLanguageProvider";
import { replaceInlineLinks, splitListByIdentifier } from "app/utils/internationalization/TranslationPageRenderer";
import parse from "html-react-parser";
import { useEffect, useState } from "react";
import "./styles.scss";

const Index = (): JSX.Element => {
	const [language] = useGlobalLanguageState();
	const [translatedObjects, setTranslatedObjects] = useState(data.en);

	useEffect(() => {
		const newTranslatedObjects = data[language];
		type Keys = keyof typeof newTranslatedObjects;
		const parsedTranslatedObjects = {} as typeof translatedObjects;

		Object.keys(newTranslatedObjects).forEach((key: string) => {
			if (key.includes("EOLPlanningSideboxCTA")) {
				parsedTranslatedObjects[key] = {
					data: newTranslatedObjects[key as Keys].data.split(/\[{2}|\||\]{2}/)[1],
				};
			} else {
				parsedTranslatedObjects[key] = {
					data: replaceInlineLinks(newTranslatedObjects[key as Keys].data, key),
				};
			}
		});

		setTranslatedObjects(parsedTranslatedObjects);
	}, [language]);

	const qnas: any = [
		{
			question: translatedObjects.EOLPlanningStartPlanningAhead.data,
			answer: (
				<>
					<p>{translatedObjects.EOLPlanningStartPlanningAheadDetails1.data}</p>
					<p>{parse(translatedObjects.EOLPlanningStartPlanningAheadDetails2.data)}</p>
					<p>{translatedObjects.EOLPlanningStartPlanningAheadDetails3.data}</p>
					{GuidesBulletList(
						"ul",
						splitListByIdentifier(translatedObjects.EOLPlanningStartPlanningAheadDetails4.data, "*"),
					)}
					<p>{parse(translatedObjects.EOLPlanningStartPlanningAheadDetails5.data)}</p>
				</>
			),
		},
		{
			question: translatedObjects.EOLPlanningFinancial.data,
			answer: (
				<>
					<p>{translatedObjects.EOLPlanningFinancialDetails1.data}</p>
					{GuidesBulletList(
						"ul",
						splitListByIdentifier(translatedObjects.EOLPlanningFinancialDetails2.data, "*"),
					)}
					<p>{translatedObjects.EOLPlanningFinancialDetails3.data}</p>
					{GuidesBulletList(
						"ul",
						splitListByIdentifier(translatedObjects.EOLPlanningFinancialDetails4.data, "*"),
					)}
				</>
			),
		},
		{
			question: translatedObjects.EOLPlanningHealthcare.data,
			answer: (
				<>
					<p>{translatedObjects.EOLPlanningHealthcareDetails1.data}</p>
					<p>{parse(translatedObjects.EOLPlanningHealthcareDetails2.data)}</p>
					<p>{parse(translatedObjects.EOLPlanningHealthcareDetails3.data)}</p>
				</>
			),
		},
		{
			question: translatedObjects.EOLPlanningPalliativeCare.data,
			answer: splitListByIdentifier(translatedObjects.EOLPlanningPalliativeCareDetails1.data, "*").map(
				(item: string, index: number) => <p key={index}>{parse(item)}</p>,
			),
		},
		{
			question: translatedObjects.EOLPlanningCaregiver.data,
			answer: (
				<>
					<p>{translatedObjects.EOLPlanningCaregiverDetails1.data}</p>
					{splitListByIdentifier(translatedObjects.EOLPlanningCaregiverDetails2.data, "*").map(
						(item: string, index: number) => (
							<p key={index}>{parse(item)}</p>
						),
					)}
				</>
			),
		},
	];

	const questionAnswer: IQuestionAnswer[] = insertCategoryAndIndex(qnas, "eolp");

	return (
		<div className="end-of-life-planning">
			<PageHeader title={`${translatedObjects.EOLPlanningTitle.data} - MyLegacy@LifeSG`} />
			<OverviewPage
				title={translatedObjects.EOLPlanningTitle.data}
				description={translatedObjects.EOLPlanningSubtitle.data}
				questionAndAnswers={questionAnswer}
				sideboxText={[
					translatedObjects.EOLPlanningSideboxText.data,
					translatedObjects.EOLPlanningSideboxCTA.data,
				]}
				otherTerms={{
					expandText: translatedObjects.EOLPlanningExpandAll.data,
					collapseText: translatedObjects.EOLPlanningCollapseAll.data,
				}}
			/>
		</div>
	);
};

// This is where all the content will be
// and will be passed to OverviewPage to handle the presentation

export default Index;
